import type { ReactNode } from 'react'

export const isChildrenRenderFunction = <C extends ReactNode>(
  // eslint-disable-next-line @typescript-eslint/ban-types
  children: C | Function,
) => typeof children === 'function'
